import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import ListSettingsManagement from '../../../components/siteadmin/ListSettingsManagement';
import s from './ListSettings.css';

const ListSettings = (props) => {

  const { title, typeId } = props;

  return <ListSettingsManagement typeId={typeId} />

}

export default withStyles(s)(ListSettings);
